'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Subject = require('rxjs/Subject');

var _Model2 = require('./Model');

var _Model3 = _interopRequireDefault(_Model2);

var _states = require('./states');

var _StateMutationSubject = require('./rx/StateMutationSubject');

var _StateMutationSubject2 = _interopRequireDefault(_StateMutationSubject);

var _FormSubject = require('./rx/FormSubject');

var _FormSubject2 = _interopRequireDefault(_FormSubject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Form = function (_Model) {
  _inherits(Form, _Model);

  /**
   * Create Form instance
   * @param {{}} data
   * @param {{}} context
   * @param {string|[string]} scenario
   */


  /**
   * Подписка на прослушивание модели. Форма следит за атрибутами
   * Если приходит UnvalidatedState - автоматически перевалидируем аттрибут
   * @type {Subscription}
   */


  /**
   * @type {Array<string>}
   */

  /**
   * @type {{}}
   */
  function Form() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var scenario = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _Model3.default.SCENARIO_DEFAULT;

    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, data, context, scenario));

    _this.state = {};
    _this.dirtyAttributes = [];
    _this.stateObservable = new _Subject.Subject();


    _this.validationSubscription = _this.getValidationObservable().subscribe(function (state) {
      if (state instanceof _states.UnvalidatedState) {
        setTimeout(function () {
          return _this.validateAttributes([state.attribute]);
        }, 0);
      }

      return null;
    });

    _this.initialState = _this.state;
    return _this;
  }

  /**
   * Form state stream
   * @returns {StateMutationSubject}
   */

  /**
   * @type {{}}
   */


  _createClass(Form, [{
    key: 'getStateObservable',
    value: function getStateObservable() {
      return new _StateMutationSubject2.default(this);
    }

    /**
     * Aggregated stream
     * @returns {FormSubject}
     */

  }, {
    key: 'getObservable',
    value: function getObservable() {
      return new _FormSubject2.default(this);
    }

    /**
     * Mark attribute as dirty
     * @param attribute
     */

  }, {
    key: 'markAsDirty',
    value: function markAsDirty(attribute) {
      if (this.dirtyAttributes.indexOf(attribute) === -1) {
        this.dirtyAttributes.push(attribute);
      }
    }

    /**
     * Set form state property value
     * @param {string} name
     * @param {*} value
     */

  }, {
    key: 'setStateValue',
    value: function setStateValue(name, value) {
      this.state = Object.assign({}, this.state, _defineProperty({}, name, value));

      this.stateObservable.next(new _states.StateMutation(_defineProperty({}, name, value)));
    }

    /**
     * Get form state property value
     * @param {string} name
     * @returns {*}
     */

  }, {
    key: 'getStateValue',
    value: function getStateValue(name) {
      return this.state[name];
    }

    /**
     * Set state values
     * @param {Object<string, *>} values
     */

  }, {
    key: 'setState',
    value: function setState(values) {
      this.state = Object.assign({}, this.state, values);

      this.stateObservable.next(new _states.StateMutation(values));
    }

    /**
     * Set model attribute
     * @param attribute
     * @param value
     * @param {boolean} safe
     */

  }, {
    key: 'setAttribute',
    value: function setAttribute(attribute, value) {
      var safe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      this.set(attribute, value, safe);

      this.markAsDirty(attribute);
    }

    /**
     * Set model attribute and validate it
     * @param attribute
     * @param value
     * @param {boolean} safe
     * @returns {Promise.<boolean>}
     */

  }, {
    key: 'setAttributeAndValidate',
    value: function setAttributeAndValidate(attribute, value) {
      var safe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      this.setAttribute(attribute, value, safe);

      return this.validateAttributes([attribute]);
    }

    /**
     * Get model attribute
     * @param attribute
     * @returns {*}
     */

  }, {
    key: 'getAttribute',
    value: function getAttribute(attribute) {
      return this.get(attribute);
    }

    /**
     * Set model attributes
     * @param {Object} values
     * @param {boolean} safe
     */

  }, {
    key: 'setAttributes',
    value: function setAttributes(values) {
      var _this2 = this;

      var safe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      Object.entries(values).forEach(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            k = _ref3[0],
            v = _ref3[1];

        _this2.set(k, v, safe);

        _this2.markAsDirty(k);
      });
    }

    /**
     * Set model attributes and validate them
     * @param values
     * @returns {Promise.<boolean>}
     */

  }, {
    key: 'setAttributesAndValidate',
    value: function setAttributesAndValidate(values) {
      this.setAttributes(values);

      return this.validateAttributes(Object.keys(values));
    }
  }, {
    key: 'isFormDirty',
    value: function isFormDirty() {
      return !!this.dirtyAttributes.length;
    }
  }, {
    key: 'isFormValid',
    value: function isFormValid() {
      return !this.isModelHasErrors();
    }
  }, {
    key: 'isFormChanged',
    value: function isFormChanged() {
      return this.initialState !== this.state;
    }
  }, {
    key: 'isAttributeDirty',
    value: function isAttributeDirty(attribute) {
      return this.isAttributeChanged(attribute) || this.dirtyAttributes.indexOf(attribute) !== -1;
    }

    /**
     * @param {Array<string>|string} attributes
     * @returns {Promise<boolean>}
     */

  }, {
    key: 'validate',
    value: function validate() {
      var _this3 = this;

      var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (Array.isArray(attributes) && !attributes.length) {
        // помечаем все безопасные аттрибуты как "грязные"
        Object.keys(this.getValidators()).forEach(function (attribute) {
          return _this3.markAsDirty(attribute);
        });
      } else {
        // добавляем аттрибуты в список "грязных"
        this.dirtyAttributes = [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(this.dirtyAttributes), _toConsumableArray(typeof attributes === 'string' ? [attributes] : attributes)))));
      }

      return _get(Form.prototype.__proto__ || Object.getPrototypeOf(Form.prototype), 'validate', this).call(this, attributes);
    }

    /**
     * Validate Form
     * @param attributes {Array<string>|string}
     * @param onlyDirtyAttributes {boolean}
     * @returns {Promise.<boolean>}
     */

  }, {
    key: 'validateAttributes',
    value: function validateAttributes(attributes) {
      var _this4 = this;

      var onlyDirtyAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var attrsToCheck = (typeof attributes === 'string' ? [attributes] : attributes) || [];

      if (onlyDirtyAttributes) {
        attrsToCheck = attrsToCheck.filter(function (i) {
          return _this4.isAttributeDirty(i);
        });
      }

      if (attrsToCheck.length) {
        return this.validate(attrsToCheck);
      }

      return Promise.resolve(true);
    }

    /**
     * Validate Form's dirty attributes
     * @returns {Promise.<boolean>}
     */

  }, {
    key: 'validateDirtyAttributes',
    value: function validateDirtyAttributes() {
      if (this.dirtyAttributes.length) {
        return this.validate(this.dirtyAttributes);
      }

      return Promise.resolve(true);
    }
  }]);

  return Form;
}(_Model3.default);

exports.default = Form;


//////////////////
// WEBPACK FOOTER
// ./~/rx-model/Form.js
// module id = 752
// module chunks = 0